import React from "react";
import { Modal } from "reactstrap";
import { connect } from "react-redux";
import ModalHeader from "reactstrap/lib/ModalHeader";
import { closeInteractivityModal } from "../../redux/modal/action";
import { language } from "../../languageProvider/language/language";
import { defaultLanguage, sendAnalyticsEvent } from "../../helper/utility";
import Button from "reactstrap/lib/Button";
import ModalBody from "reactstrap/lib/ModalBody";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { isIOS } from "react-device-detect";
import Facebook from "../../assets/images/icons/facebook.svg";
import Whatsapp from "../../assets/images/icons/whatsapp.svg";
import ModalFooter from "reactstrap/lib/ModalFooter";
import ContentModal from "./modalbody/ContentModal";
import Marker from "../leaflet/markers/Marker";
import { serverResponse } from "../../util/fakeServer";
import { gaEventLabel } from "../../settings/gaConfig";
import LoaderModal from "../common/LoaderModal";

const ModalComponent = (props) => {
  const otherPropsModal = props.modalRedux.staticContent;
  const fakeServerConfig = props.fakeServer.config;
  const productUrl = serverResponse.config.shareFlyerURL;

  const closeBtn = (
    <Button
      color="secondary"
      onClick={() => {
        if (props.zoom !== undefined) {
          props.zoom.reset();
        }
        props.closeInteractivityModal();
      }}
    >
      <i className="fas fa-arrow-left"></i>
      <strong> {language[defaultLanguage].indietro}</strong>
    </Button>
  );

  const shareOnFacebook = () => {
    sendAnalyticsEvent(
      gaEventLabel.share_product_facebook,
      String(otherPropsModal.info.skul)
    );

    let fb_share_url = "https://www.facebook.com/share.php?u=";
    let page_url =
      productUrl +
      "/share/product.php?c=" +
      otherPropsModal.info.skul +
      `&img=${props.modalRedux.dynamicContent.images[0].image_file}`;
    window.open(
      fb_share_url + encodeURIComponent(page_url),
      "_blank",
      "location=yes,height=570,width=520,scrollbars=yes,status=yes"
    );
  };

  const shareOnWhatsapp = () => {
    sendAnalyticsEvent(
      gaEventLabel.share_product_whatsapp,
      String(otherPropsModal.info.skul)
    );

    let page_url =
      productUrl +
      "/share/product.php?c=" +
      otherPropsModal.info.skul +
      `&img=${props.modalRedux.dynamicContent.images[0].image_file}`;
    if (window.ReactNativeWebView !== undefined && isIOS) {
      let link = encodeURIComponent(page_url);
      let title = serverResponse.config.shareProductSentence;
      var str = title + " " + link;
      var obj = { action: "whatsapp", value: str };
      window.ReactNativeWebView.postMessage(JSON.stringify(obj));
    } else {
      window.open(
        "http://api.whatsapp.com/send?text=" +
          serverResponse.config.shareProductSentence +
          " " +
          encodeURIComponent(page_url),
        "_blank",
        "location=yes,height=570,width=520,scrollbars=yes,status=yes"
      );
    }
  };

  return (
    <Modal
      isOpen={props.modalRedux.isModalOpen}
      toggle={() => {
        props.closeInteractivityModal();
      }}
      size="xl"
      onOpened={() => {
        if (otherPropsModal.disableSwipe !== undefined)
          otherPropsModal.disableSwipe();
      }}
      onClosed={() => {
        if (otherPropsModal.enableSwipe !== undefined)
          otherPropsModal.enableSwipe();
      }}
    >
      <ModalHeader
        toggle={() => props.closeInteractivityModal()}
        close={closeBtn}
      >
        {language[defaultLanguage].descrizione}
      </ModalHeader>
      <ModalBody>
        <Row style={{ marginBottom: "16px" }}>
          {props.modalRedux.loading ? (
            <LoaderModal width="50vw" height="50vh" />
          ) : (
            !props.modalRedux.error && (
              <Col style={{ display: "flex", height: "30px" }}>
                <div className="markers-container" style={{ width: "100%" }}>
                  <div className="vertical" style={{ display: "flex" }}>
                    {props.modalRedux.staticContent.info.markers
                      .filter(
                        (el) =>
                          el.type !== "video" &&
                          el.type !== props.modalRedux.staticContent.type
                      )
                      .map((el, index) => (
                        <Marker
                          key={index}
                          info={props.modalRedux.staticContent.info}
                          markerInfo={el}
                          leafletSwipe={props.leafletSwipe}
                          type={el.type}
                        />
                      ))}
                  </div>
                  {!fakeServerConfig.hide_share_product && (
                    <img
                      src={Facebook}
                      className="share-icon"
                      style={{ marginLeft: "auto" }}
                      alt="facebook"
                      onClick={() => shareOnFacebook()}
                    />
                  )}
                  {!fakeServerConfig.hide_share_product && (
                    <img
                      src={Whatsapp}
                      className="share-icon"
                      alt="whatsapp"
                      onClick={() => shareOnWhatsapp()}
                    />
                  )}
                </div>
              </Col>
            )
          )}
        </Row>
        {/* CONTENUTO DINAMICO MODALE */}
        {!props.modalRedux.loading && !props.modalRedux.error && (
          <Row>
            <ContentModal {...props.modalRedux.staticContent} />
          </Row>
        )}
        {/* GESTIONE ERRORE MODALE */}
        {!props.modalRedux.loading && props.modalRedux.error && (
          <Row>
            <h6 className="p-3">
              Attenzione questo prodotto non è più disponibile!
            </h6>
          </Row>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            if (props.zoom !== undefined) {
              otherPropsModal.zoom.reset();
            }
            props.closeInteractivityModal();
            // this.setModal(true);
          }}
        >
          {language[defaultLanguage].chiudi}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    modalRedux: state.modal,
    fakeServer: state.fakeServer
  };
};

export default connect(mapStateToProps, {
  closeInteractivityModal
})(ModalComponent);
